import Styles from "./StartingLineup.module.scss";

export default function StartingLineupPage() {
  return <h1>Not Implemented</h1>;
}
